// src/components/Spinner.js
import React from 'react';
import './Spinner.css';

export default function Spinner() {
  return (
    <div className="login-spinner-overlay">
      <div className="login-spinner"></div>
    </div>
  );
}
